import { format } from 'date-fns'

/**
 * 2024-05-01T00:00:00+09:00
 * などの形式を読み込む。
 *
 * Localeの情報はあえて利用しないようにするために、正規表現を利用して文字列を取得するようにしている
 * */
const decodeYMD = ({
  time,
}: { time: string }): { year: string; month: string; day: string; hour: string; minute: string } => {
  const match = time.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/)
  if (match) {
    const year = match[1]
    const month = match[2]
    const day = match[3]
    const hour = match[4]
    const minute = match[5]
    //console.log(`年: ${year}, 月: ${month}, 日: ${day}`)
    // 出力: 年: 2024, 月: 05, 日: 01
    return { year, month, day, hour, minute }
  }
  return { year: '', month: '', day: '', hour: '', minute: '' }
}

export function time({ time, language }: { time: string; language: string }) {
  if (time === '' || !time) return
  const { year, month, day } = decodeYMD({ time })
  //const datetime = new Date(time)
  const jpDate = `${year}年${month}月${day}日`
  const enDate = `${month}/${day}/${year}`
  if (language === 'en_US' || language === 'en') {
    return enDate
  } else if (language === 'ko_KR') {
    return `${year}년${month}월${day}일`
  } else if (language === 'zh_TW') {
    return `民國${Number.parseInt(year) - 1911}年${month}月${day}日`
  } else if (language === 'zh_CH') {
    // 日本と変わらなさそうなため
    return jpDate
  }
  return jpDate
}

export function formatTimeWithHour({ time }: { time: string }) {
  if (!time) return ''
  const datetime = new Date(time)
  return format(datetime, 'yyyy/MM/dd HH:mm')
}
